import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { dinero, fechaHora, hora, METODOS, variante } from "./posApi";

const ANCHO = 8; // cm, impresora de tickets de 80mm
const NOMBRE = process.env.REACT_APP_NOMBRE_INSTITUCION || "";

// Imprime en un iframe oculto: no lo bloquea el navegador y abre directo el diálogo de impresión
const imprimir = (doc) => {
  doc.autoPrint();
  const url = doc.output("bloburl");
  const previo = document.getElementById("pos-print-frame");
  if (previo) previo.remove();
  const f = document.createElement("iframe");
  f.id = "pos-print-frame";
  f.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;";
  f.src = url;
  document.body.appendChild(f);
};

const encabezado = (doc, titulo, tienda) => {
  let y = 0.8;
  doc.setFontSize(11).setFont(undefined, "bold");
  doc.text(NOMBRE, ANCHO / 2, y, { align: "center" });
  y += 0.5;
  doc.setFontSize(8).setFont(undefined, "normal");
  if (tienda) {
    doc.text(tienda.name || "", ANCHO / 2, y, { align: "center" });
    y += 0.4;
    if (tienda.direccion) { doc.text(doc.splitTextToSize(tienda.direccion, ANCHO - 1), ANCHO / 2, y, { align: "center" }); y += 0.4; }
  }
  doc.setFont(undefined, "bold");
  doc.text(titulo, ANCHO / 2, y, { align: "center" });
  doc.setFont(undefined, "normal");
  return y + 0.3;
};

const tabla = (doc, y, head, body, opts = {}) => {
  doc.autoTable({
    startY: y, head: [head], body, theme: "plain", margin: { left: 0.3, right: 0.3 },
    styles: { fontSize: 7, cellPadding: 0.05 }, headStyles: { fontStyle: "bold" }, ...opts,
  });
  return doc.autoTable.previous.finalY + 0.2;
};

const linea = (doc, y, izq, der, negrita) => {
  doc.setFont(undefined, negrita ? "bold" : "normal");
  doc.text(izq, 0.3, y);
  doc.text(der, ANCHO - 0.3, y, { align: "right" });
  doc.setFont(undefined, "normal");
  return y + 0.4;
};

export const ticketVenta = (v) => {
  const alto = 11 + v.renglones.length * 1.2;
  const doc = new jsPDF("p", "cm", [ANCHO, alto]);
  let y = encabezado(doc, `Ticket ${v.areas && v.areas.clave ? v.areas.clave + "-" : ""}${v.folio}`, v.areas);
  doc.setFontSize(7);
  doc.text(fechaHora(v.fecha), 0.3, y);
  doc.text(v.user ? `Atendió: ${v.user.nombre}` : "", ANCHO - 0.3, y, { align: "right" });
  y += 0.2;
  y = tabla(doc, y, ["Cant", "Artículo", "Importe"],
    v.renglones.map((r) => [
      r.cantidad,
      `${r.codigo} ${r.nombre || ""}${variante(r) ? "\n" + variante(r) : ""}\n${r.cantidad} x ${dinero(r.precioLista)}${r.promociones && r.promociones.length ? "\n" + r.promociones.join(", ") : ""}`,
      dinero(r.importe),
    ]),
    { columnStyles: { 0: { cellWidth: 0.8 }, 2: { halign: "right", cellWidth: 1.8 } } });
  doc.setFontSize(8);
  if (v.descuento > 0) {
    y = linea(doc, y, "Subtotal", dinero(v.subtotal));
    y = linea(doc, y, "Ahorro por promociones", "-" + dinero(v.descuento));
  }
  y = linea(doc, y, "TOTAL", dinero(v.total), true);
  v.pagos.forEach((p) => { y = linea(doc, y, METODOS[p.metodo], dinero(p.metodo === "efectivo" ? p.importe + (v.cambio || 0) : p.importe)); });
  if (v.cambio > 0) y = linea(doc, y, "Cambio", dinero(v.cambio), true);
  y += 0.2;
  doc.setFontSize(7);
  doc.text(`${v.piezas} pieza(s)`, 0.3, y);
  if (v.estatus === "Cancelada") { y += 0.5; doc.setFont(undefined, "bold"); doc.text("*** CANCELADA ***", ANCHO / 2, y, { align: "center" }); }
  y += 0.6;
  doc.text("¡Gracias por su compra!", ANCHO / 2, y, { align: "center" });
  imprimir(doc);
};

export const ticketCorte = (c) => {
  const doc = new jsPDF("p", "cm", [ANCHO, 19 + ((c.ventas ? c.ventas.length : 0) + (c.devoluciones ? c.devoluciones.length : 0) + (c.caja ? c.caja.length * 2 : 0)) * 0.35]);
  let y = encabezado(doc, `Corte de caja ${c.folio}`, c.areas);
  doc.setFontSize(7);
  doc.text(`Hecho: ${fechaHora(c.fecha)}  ·  ${c.user ? c.user.nombre + " " + c.user.apellido : ""}`, 0.3, y);
  y += 0.4;
  doc.text(`Ventas del ${fechaHora(c.desde)} al ${fechaHora(c.hasta)}`, 0.3, y);
  y += 0.2;
  y = tabla(doc, y, ["", "Sistema", "Entregado", "Dif."],
    ["efectivo", "tdc", "transfer", "total"].map((k) => [
      k === "total" ? "TOTAL" : METODOS[k], dinero(c.sistema[k]), dinero(c.entregado[k]), dinero(c.diferencia[k]),
    ]),
    { columnStyles: { 1: { halign: "right" }, 2: { halign: "right" }, 3: { halign: "right" } } });
  doc.setFontSize(8);
  y = linea(doc, y, "Ventas", String(c.numVentas));
  y = linea(doc, y, "Canceladas", String(c.numCanceladas));
  y = linea(doc, y, "Piezas", String(c.piezas));
  y = linea(doc, y, "Descuentos otorgados", dinero(c.descuentos));
  if (c.numMovCaja) {
    y = linea(doc, y, "Ventas en efectivo", dinero(c.ventasEfectivo));
    if (c.fondos) y = linea(doc, y, "Fondo de caja", "+" + dinero(c.fondos));
    if (c.gastos) y = linea(doc, y, "Gastos", "-" + dinero(c.gastos));
    if (c.retiros) y = linea(doc, y, "Retiros", "-" + dinero(c.retiros));
  }
  if (c.numDevoluciones) {
    y = linea(doc, y, "Devoluciones / cambios", String(c.numDevoluciones));
    y = linea(doc, y, "Dinero regresado", dinero(c.reembolsado));
  }
  if (c.fondoQueda) {
    y = linea(doc, y, "Se queda de fondo", dinero(c.fondoQueda));
    y = linea(doc, y, "Efectivo entregado", dinero(c.efectivoEntregado), true);
  }
  if (c.observaciones) { doc.setFontSize(7); doc.text(doc.splitTextToSize("Obs: " + c.observaciones, ANCHO - 0.6), 0.3, y); y += 0.8; }
  if (c.devoluciones && c.devoluciones.length) {
    y = tabla(doc, y, ["Dev.", "Ticket", "Saldo fav.", "Regresado"],
      c.devoluciones.map((d) => [d.folio, d.ventaFolio, dinero(d.credito), d.reembolso && d.reembolso.importe ? `${dinero(d.reembolso.importe)} ${METODOS[d.reembolso.metodo]}` : ""]),
      { columnStyles: { 2: { halign: "right" }, 3: { halign: "right" } } });
  }
  if (c.caja && c.caja.length) {
    y = tabla(doc, y, ["Mov.", "Concepto", "Importe"],
      c.caja.filter((m) => m.estatus === "Activo").map((m) => [`${m.tipo} ${m.folio}`, m.concepto + (m.recibio ? `\n${m.recibio}` : ""), (m.tipo === "Fondo" ? "+" : "-") + dinero(m.importe)]),
      { columnStyles: { 2: { halign: "right" } } });
  }
  if (c.ventas && c.ventas.length) {
    y = tabla(doc, y, ["Folio", "Hora", "Total", ""],
      c.ventas.map((v) => [v.folio, hora(v.fecha), dinero(v.total), v.estatus === "Cancelada" ? "CANC" : ""]),
      { columnStyles: { 2: { halign: "right" } } });
  }
  y += 1;
  doc.text("_______________________", ANCHO / 2, y, { align: "center" });
  doc.text("Firma de quien entrega", ANCHO / 2, y + 0.4, { align: "center" });
  imprimir(doc);
};

// Comprobante de devolución o cambio (si hubo venta nueva, también se imprime ese ticket)
export const ticketDevolucion = (d, ventaOriginal) => {
  const doc = new jsPDF("p", "cm", [ANCHO, 12 + d.renglones.length * 0.8 + (d.ventaNueva ? d.ventaNueva.renglones.length * 0.8 : 0)]);
  let y = encabezado(doc, `${d.tipo} ${d.folio}`, d.areas);
  doc.setFontSize(7);
  doc.text(`${fechaHora(d.fecha)} · Ticket original ${ventaOriginal ? ventaOriginal.folio : d.ventaFolio}`, 0.3, y);
  y += 0.2;
  y = tabla(doc, y, ["Cant", "Regresa", ""], d.renglones.map((r) => [r.cantidad, `${r.codigo} ${r.nombre || ""}${variante(r) ? "\n" + variante(r) : ""}`, dinero(r.importe)]),
    { columnStyles: { 0: { cellWidth: 0.8 }, 2: { halign: "right", cellWidth: 1.8 } } });
  doc.setFontSize(8);
  y = linea(doc, y, "Saldo a favor", dinero(d.credito), true);
  if (d.ventaNueva) {
    y = tabla(doc, y, ["Cant", "Se lleva", ""], d.ventaNueva.renglones.map((r) => [r.cantidad, `${r.codigo} ${r.nombre || ""}${variante(r) ? "\n" + variante(r) : ""}${r.promociones && r.promociones.length ? "\n" + r.promociones.join(", ") : ""}`, dinero(r.importe)]),
      { columnStyles: { 0: { cellWidth: 0.8 }, 2: { halign: "right", cellWidth: 1.8 } } });
    doc.setFontSize(8);
    y = linea(doc, y, `Venta nueva ${d.ventaNueva.folio}`, dinero(d.ventaNueva.total));
    y = linea(doc, y, "Saldo a favor aplicado", "-" + dinero(d.aplicado));
    d.ventaNueva.pagos.filter((p) => p.metodo !== "cambio").forEach((p) => { y = linea(doc, y, METODOS[p.metodo], dinero(p.importe)); });
    if (d.ventaNueva.cambio > 0) y = linea(doc, y, "Cambio", dinero(d.ventaNueva.cambio));
  }
  if (d.reembolso && d.reembolso.importe > 0) y = linea(doc, y, `Se regresa (${METODOS[d.reembolso.metodo]})`, dinero(d.reembolso.importe), true);
  if (d.motivo) { doc.setFontSize(7); doc.text(doc.splitTextToSize("Motivo: " + d.motivo, ANCHO - 0.6), 0.3, y); y += 0.6; }
  y += 0.8;
  doc.setFontSize(7);
  doc.text("_______________________", ANCHO / 2, y, { align: "center" });
  doc.text("Firma del cliente", ANCHO / 2, y + 0.4, { align: "center" });
  imprimir(doc);
};

// Hoja de traspaso para quien lleva la mercancía (firmas de entrega y recibo)
export const ticketTraspaso = (t) => {
  const doc = new jsPDF("p", "cm", [ANCHO, 13 + t.renglones.length * 0.9]);
  let y = encabezado(doc, `Traspaso ${t.origen && t.origen.clave ? t.origen.clave + "-" : ""}${t.folio}`, null);
  doc.setFontSize(8);
  y = linea(doc, y, "Sale de", t.origen ? t.origen.name : "");
  y = linea(doc, y, "Va a", t.destino ? t.destino.name : "", true);
  doc.setFontSize(7);
  doc.text(`${fechaHora(t.fecha)} · ${t.user ? t.user.nombre : ""}`, 0.3, y); y += 0.2;
  const recibido = t.estatus !== "En tránsito" && t.estatus !== "Cancelado";
  y = tabla(doc, y, recibido ? ["Envía", "Artículo", "Recibe"] : ["Cant", "Artículo", "Recibe"],
    t.renglones.map((r) => [r.cantidad, `${r.codigo} ${r.nombre || ""}${variante(r) ? "\n" + variante(r) : ""}`, recibido ? r.recibido : "____"]),
    { columnStyles: { 0: { cellWidth: 0.9 }, 2: { halign: "center", cellWidth: 1.2 } } });
  doc.setFontSize(8);
  y = linea(doc, y, "Piezas enviadas", String(t.piezas), true);
  if (recibido) y = linea(doc, y, "Piezas recibidas", String(t.piezasRecibidas), true);
  if (t.observaciones) { doc.setFontSize(7); doc.text(doc.splitTextToSize("Obs: " + t.observaciones, ANCHO - 0.6), 0.3, y); y += 0.6; }
  y += 1;
  doc.setFontSize(7);
  doc.text("____________", 1.9, y, { align: "center" }); doc.text("____________", 6.1, y, { align: "center" });
  doc.text("Entrega", 1.9, y + 0.4, { align: "center" }); doc.text("Recibe", 6.1, y + 0.4, { align: "center" });
  imprimir(doc);
};

// Comprobante de gasto, retiro o fondo de caja (con firma)
export const ticketCaja = (m) => {
  const doc = new jsPDF("p", "cm", [ANCHO, 10]);
  let y = encabezado(doc, `${m.tipo === "Fondo" ? "Fondo de caja" : m.tipo} ${m.folio}`, m.areas);
  doc.setFontSize(7);
  doc.text(`${fechaHora(m.fecha)} · ${m.user ? m.user.nombre : ""}`, 0.3, y); y += 0.5;
  doc.setFontSize(8);
  y = linea(doc, y, "Concepto", m.concepto || "");
  if (m.descripcion) { doc.setFontSize(7); doc.text(doc.splitTextToSize(m.descripcion, ANCHO - 0.6), 0.3, y); y += 0.5; doc.setFontSize(8); }
  if (m.recibio) y = linea(doc, y, "Recibe", m.recibio);
  y = linea(doc, y, "Importe", dinero(m.importe), true);
  if (m.estatus === "Cancelado") { doc.setFont(undefined, "bold"); doc.text("*** CANCELADO ***", ANCHO / 2, y, { align: "center" }); doc.setFont(undefined, "normal"); y += 0.5; }
  y += 1.2;
  doc.setFontSize(7);
  if (m.tipo === "Retiro") {
    doc.text("____________", 1.9, y, { align: "center" }); doc.text("____________", 6.1, y, { align: "center" });
    doc.text("Entrega", 1.9, y + 0.4, { align: "center" }); doc.text("Recibe", 6.1, y + 0.4, { align: "center" });
  } else {
    doc.text("_______________________", ANCHO / 2, y, { align: "center" });
    doc.text("Firma", ANCHO / 2, y + 0.4, { align: "center" });
  }
  imprimir(doc);
};
